import {
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__REQUEST:
    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__SUCCESS:
      return null;

    case ACTION_DELETE_SITE_FOOTER_LINK_CATEGORY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
